// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__25QVe","none":"Modal_none__1GVPL"};